import React from 'react'
import { FiArrowLeft } from 'react-icons/fi'
import '../styles/components/LoginBackButton.css'

const LoginBackButton = ({ onClick }) => {
  return (
    <FiArrowLeft color='var(--primary)' size={24}
      className='login-back-button-container' onClick={onClick} />
  )
}

export default LoginBackButton



// WEBPACK FOOTER //
// ./src/components/LoginBackButton.js